import { useEffect, useState } from 'react';
import { getMasks, putMask } from '../api';

export default function Masks() {
  const [masks, setMasks] = useState<Record<string, number>>({});
  const [prefix, setPrefix] = useState('');
  const [ratio, setRatio] = useState<number>(0.5);
  const [err, setErr] = useState<string | null>(null);

  async function load() {
    try {
      setErr(null);
      setMasks(await getMasks());
    } catch (e) {
      setErr(String(e));
    }
  }
  useEffect(() => void load(), []);

  async function save(e: React.FormEvent) {
    e.preventDefault();
    if (!prefix.trim()) return;
    try {
      await putMask(prefix.trim(), ratio);
      setPrefix('');
      setRatio(0.5);
      await load();
    } catch (err) {
      setErr(String(err));
    }
  }

  return (
    <div>
      <h2>プリフィックス マスク</h2>

      <div className="card">
        <h3>設定・上書き</h3>
        <p className="muted">
          `aihara` に 0.8 をセットすると `aihara*` 端末は 24 枠のうち ceil(24 ×
          0.8) = 20 枠が「広告出さない」時間になる。
        </p>
        <form onSubmit={save} className="row" style={{ marginTop: 8 }}>
          <input
            placeholder="プリフィックス"
            value={prefix}
            onChange={(e) => setPrefix(e.target.value)}
            style={{ minWidth: 200 }}
          />
          <input
            type="number"
            min={0}
            max={1}
            step={0.05}
            value={ratio}
            onChange={(e) => setRatio(Number(e.target.value))}
            style={{ width: 100 }}
          />
          <button disabled={!prefix.trim()}>保存</button>
        </form>
        {err && <div className="error">{err}</div>}
      </div>

      <div className="card">
        <h3>現在の設定</h3>
        <table>
          <thead>
            <tr>
              <th>プリフィックス</th>
              <th>マスク率</th>
              <th>マスク枠数 (24×切上)</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(masks).map(([p, r]) => (
              <tr key={p}>
                <td>
                  <strong>{p}</strong>
                </td>
                <td>{(r * 100).toFixed(0)}%</td>
                <td>{Math.ceil(24 * r)} / 24</td>
                <td>
                  <button
                    className="ghost small"
                    onClick={() => {
                      setPrefix(p);
                      setRatio(r);
                    }}
                  >
                    編集
                  </button>
                </td>
              </tr>
            ))}
            {Object.keys(masks).length === 0 && (
              <tr>
                <td colSpan={4} className="muted">
                  未設定
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
